<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item label="订单号">
            <el-input
              v-model="form.orderId"
              placeholder="订单号"
              style="width: 260px"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="$store.state.roleId == '1070960390067716097' || $store.state.roleId == '2125410685723869666'"
            label="商户名称"
          >
            <el-select
              v-model="form.appId"
              filterable
              placeholder="--请选择--"
              :popper-append-to-body="false"
              popper-class="eloption"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="余额版本开始">
            <el-input
              v-model="form.balanceVersionStart"
              placeholder="余额版本开始"
              style="width: 120px"
            ></el-input>
          </el-form-item>
          <el-form-item label="余额版本结束">
            <el-input
              v-model="form.balanceVersionEnd"
              placeholder="余额版本结束"
              style="width: 120px"
            ></el-input>
          </el-form-item>

          <el-form-item label="交易类型">
            <el-select
              v-model="form.transType"
              filterable
              placeholder="--请选择--"
            >
              <el-option label="请选择" value=""></el-option>
              <el-option label="代收成功" value="11"></el-option>
              <el-option label="代收退款" value="10"></el-option>
              <el-option label="代付退款" value="21"></el-option>
              <el-option label="代付失败" value="22"></el-option>
              <el-option label="代付发起" value="20"></el-option>
              <el-option label="充值成功" value="31"></el-option>
              <el-option label="提现成功" value="30"></el-option>
              <el-option label="上线清零" value="40"></el-option>
              <el-option label="代理结算" value="50"></el-option>
              <el-option label="代理提现" value="51"></el-option>
              <el-option label="冲正扣减" value="61"></el-option>
              <el-option label="冲正增加" value="62"></el-option>

            </el-select>
          </el-form-item>

          <el-form-item label="出入帐">
            <el-select
              v-model="form.balanceTrend"
              filterable
              placeholder="--请选择--"
            >
              <el-option label="请选择" value=""></el-option>
              <el-option label="入账" value="1"></el-option>
              <el-option label="出账" value="-1"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="业务时间">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item> -->

          <el-form-item label="日期">
            <el-date-picker
              v-model="timeDate"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyyMMddHHmmss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button
            :loading="loading"
            type="primary"
            @click="exportDetail"
            size="small"
          >
            导出流水</el-button
          >
        </template>

        <template slot="tableColumn">
          <el-table-column
            width="110px"
            prop="agentId"
            label="agentId"
            align="center"
          ></el-table-column>
          <el-table-column
            width="120px"
            prop="appId"
            label="appId"
            align="center"
          ></el-table-column>

          <el-table-column
            width="300px"
            prop="orderId"
            label="订单号"
            align="center"
          ></el-table-column>

          <el-table-column
            width="160"
            prop="bizTimeStr"
            label="业务时间"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="transType"
            label="交易类型"
            width="100px"
            :formatter="$formatter.formatTransType"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                size="small"
                :type="
                  row.transType == '20' ||
                  row.transType == '21' ||
                  row.transType == '22'
                    ? 'warning'
                    : row.transType == '11' || row.transType == '10'
                    ? 'success'
                    : 'primary'
                "
                >{{
                  $formatter.formatTransType(null, null, row.transType, null)
                }}</el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="orderAmount"
            :formatter="$formatter.FenToYuan"
            width="120px"
            label="交易金额"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="actualAmount"
            :formatter="$formatter.FenToYuan"
            width="120px"
            label="变动金额"
            align="center"
          ></el-table-column>

          <el-table-column
            width="100"
            prop="balanceTrend"
            label="商户出入帐"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.balanceTrend == 1" type="success" size="mini"
                >入账</el-tag
              >
              <el-tag v-else type="danger" size="mini">出账</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="currentBalanceStr"
            width="140px"
            label="变动后余额"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="balanceVersion"
            width="120px"
            label="余额版本"
            align="center"
          ></el-table-column>

          <el-table-column width="80" prop="remark" label="备注" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.remark">
                <el-popover
                  v-if="row.remark && row.remark.length > 10"
                  placement="top-start"
                  width="80"
                  trigger="hover"
                  :content="row.remark"
                >
                  <div slot="reference" class="remark">
                    {{ row.remark }}
                  </div>
                </el-popover>
                <div v-else>{{ row.remark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
            width="130"
            prop="transactionId"
            label="交易流水号"
            align="center"
          ></el-table-column>

          <el-table-column
            width="160"
            prop="createTimeStr"
            label="创建时间"
            align="center"
          ></el-table-column>

          <el-table-column
            width="380"
            prop="tradeId"
            label="跟踪ID"
            align="center"
          ></el-table-column>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from '@/components/Page.vue'
import moment from 'moment'

export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: '/transactionFlow/selectList',
      merchantList: [],
      form: {
        appId: '',
        startDate: '',
        endDate: '',
        tradeOrderId: '',
        balanceVersionStart: "",
        balanceVersionEnd: "",

      },
      timeDate: [],
      loading: false,
    }
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = moment().utcOffset("-03:00").subtract(4, 'hours').format('yyyyMMDDHH') + "0000"
        this.form.endDate = moment().utcOffset("-03:00").format('yyyyMMDD') + "235959"
        this.timeDate = [this.form.startDate, this.form.endDate]
      }
    },
    reset() {
      this.form.startDate = moment().utcOffset("-03:00").subtract(4, 'hours').format('yyyyMMDDHH') + "0000"
      this.form.endDate = moment().utcOffset("-03:00").format('yyyyMMDD') + "235959"
      this.timeDate = [this.form.startDate, this.form.endDate]
    },
    exportDetail() {
      this.loading = true
      this.axios
        .get('/transactionFlow/selectListForExport', {
          params: this.form,
        })
        .then(res => {
          if (res.code != 200) {
              this.$message({
                  message: res.msg,
                  type: 'error',
                })
          } else {
            this.$message({
                  message: res.msg,
                  type: 'success',
                })
          }
        })
        this.loading = false
    },
 
  },

  created() {
    this.form.startDate = moment().utcOffset("-03:00").subtract(4, 'hours').format('yyyyMMDDHH') + "0000"
    this.form.endDate = moment().utcOffset("-03:00").format('yyyyMMDD') + "235959"
    this.timeDate = [this.form.startDate, this.form.endDate]

    this.$axios
      .get('/merchant/selectListForOption', { params: {} })
      .then(res => {
        this.merchantList = res.data
      })
  },
}
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.el-form-item {
  margin-bottom: 5px;
}
</style>